// extracted by mini-css-extract-plugin
export default {"pageEducajob":"Page_Educajob_pageEducajob__lnTh2","tabsWrapper":"Page_Educajob_tabsWrapper__qZ4+i"};